var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwitch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10,0C4.47791,0,0,4.47791,0,10C0,15.5221,4.47791,20,10,20C15.5221,20,20,15.5243,20,10C20,4.47568,15.5221,0,10,0ZM4.19009,7.89603C4.19009,7.722,4.33066,7.57921,4.50692,7.57921L11.5484,7.57921L11.5484,5.29228C11.5484,5.01785,11.8764,4.87282,12.0772,5.06024L15.7608,8.44489C15.9728,8.639,15.8344,8.99375,15.5466,8.99375L4.50246,8.99375C4.32843,8.99375,4.18563,8.85319,4.18563,8.67693L4.18563,7.89603L4.19009,7.89603ZM15.8635,12.1017C15.8635,12.2758,15.7229,12.4186,15.5466,12.4186L8.50736,12.4186L8.50736,14.7077C8.50736,14.9821,8.17938,15.1272,7.97858,14.9398L4.29273,11.5529C4.08077,11.3588,4.2191,11.004,4.50692,11.004L15.5511,11.004C15.7251,11.004,15.8679,11.1446,15.8679,11.3208L15.8679,12.1017L15.8635,12.1017Z",
    fill: "#F3F3F3",
    fillOpacity: 1,
    style: {
      mixBlendMode: "passthrough"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/switch.0bfc9f96f3dca406892a4749e243181b.svg";
export { ForwardRef as ReactComponent };